import { useContext } from 'react';
import { Flex, Form, FormContext, RadioInput, Text, Toggle } from 'dash-ui';
import { AccountStatusesEnum, BrokerSubscriptionTypesEnum } from 'dash-common';
import { useTranslation } from 'react-i18next';

import { FormFields } from 'pages/brokers/BrokerDetailsPage/BrokerDetailsPage.constants';

const StatusesSection = () => {
  const { t } = useTranslation();
  const { stateHandlers, formState } = useContext(FormContext);

  return (
    <Flex mb={6}>
      <Form.Group>
        <Text semibold>{t('forms:labels.userStatus')}</Text>
        <Flex mt={1}>
          <Flex alignItems="center" mr={4}>
            <RadioInput
              disabled={formState.userStatus !== AccountStatusesEnum.ACTIVE}
              mr={2}
              checked={formState.userStatus === AccountStatusesEnum.ACTIVE}
            />
            <Text>{t('common:accountStatuses.ACTIVE')}</Text>
          </Flex>
          <Flex alignItems="center">
            <RadioInput
              mr={2}
              disabled={formState.userStatus !== AccountStatusesEnum.ARCHIVED}
              checked={formState.userStatus === AccountStatusesEnum.ARCHIVED}
            />
            <Text>{t('common:accountStatuses.ARCHIVED')}</Text>
          </Flex>
        </Flex>
      </Form.Group>
      <Form.Group mx={12}>
        <Text semibold>{t('pages:brokersPage.subscriptionStatus')}</Text>
        <Flex mt={1}>
          <Text>{t('common:labels.notBillable')}</Text>
          <Toggle
            // @ts-ignore
            checked={
              formState.subscriptionType ===
              BrokerSubscriptionTypesEnum.BILLABLE
            }
            flexProps={{ mx: 2 }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target;
              stateHandlers[FormFields.SubscriptionType](
                checked
                  ? BrokerSubscriptionTypesEnum.BILLABLE
                  : BrokerSubscriptionTypesEnum.DEMO
              );
            }}
          />
          <Text>{t('common:subscriptionTypes.BILLABLE')}</Text>
        </Flex>
      </Form.Group>
      <Form.Group>
        <Text semibold>{t('forms:labels.accountType')}</Text>
        <Flex mt={1}>
          <Toggle
            // @ts-ignore
            checked={!formState.isRealUser}
            flexProps={{ mr: 2 }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target;
              stateHandlers[FormFields.IsRealUser](!checked);
            }}
          />
          <Text>{t('common:labels.testAccount')}</Text>
        </Flex>
      </Form.Group>
      <Form.Group mx={12}>
        <Text semibold>{t('forms:labels.excludeFromReports')}</Text>
        <Flex mt={1}>
          <Toggle
            // @ts-ignore
            checked={formState.excludeFromReports}
            flexProps={{ mr: 2 }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target;
              stateHandlers[FormFields.ExcludeFromReports](checked);
            }}
          />
        </Flex>
      </Form.Group>
    </Flex>
  );
};

export default StatusesSection;
